export function useRecommendPlanPaywall() {
  return {
    showRecommendPlanPaywall: false,
  };
}
